import { Collection } from 'modules/core/lib/mobx-rest'

import Job from 'modules/ats/store/models/Job'

class Jobs extends Collection<Job> {
  get cacheKey(): string {
    return 'jobs'
  }

  model() {
    return Job
  }
}

const singleton: Jobs = new Jobs()

export { Jobs }

export default singleton
